import { Skeleton } from '@dashboard/ui'
import { TableCell, TableRow } from '@/ui'

export const PagesRowSkeleton = () => {
  return (
    <TableRow>
      <TableCell>
        <Skeleton className="h-[24px] w-full rounded-md" style={{ margin: '7px 0' }} />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[24px] w-full rounded-md" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[24px] w-full rounded-md" />
      </TableCell>
    </TableRow>
  )
}
